module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part-001"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "part_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1-50")])])]), _c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-001"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', [_vm._v("THE BLESSED AND THE WICKED"), _c('br')])]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Psalms+1%3A1-6&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("PSALM 1:1-6")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("If you wish to declare someone blessed, you learn how to do so and whom to call upon and the words to say in Psalm 1.")]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THANASIUS")]), _c('i', [_vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v(" 15 [")]), _vm._v("OIP"), _c('span', {
    staticClass: "small"
  }, [_vm._v(" 66]")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" The first psalm is foundational to understanding the whole book of Psalms (B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL")]), _vm._v("). It presents the crown of blessedness that will be bestowed on the one who wins the prize in Christ (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v("), a blessedness that is none other than a participation in true being (G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSSA")]), _vm._v("), true goodness, which is God (B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The blessed man in this psalm is first of all Christ (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("), from whom blessedness comes (E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USEBIUS")]), _vm._v("). We extend its meaning to refer also to those who are saved by Christ (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("), who conform themselves to Christ (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("), whether men or women (B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL")]), _vm._v("). The soul of the one who is blessed does not experience the threefold inner movement of sin (B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL")]), _vm._v(", J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("), a deepening corruption (E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USEBIUS")]), _vm._v(") that then influences others (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("), a pattern that replicates the fall of Adam in the individual soul (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIODORUS")]), _vm._v("). Such are given over to vain musings (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(") because they reject God (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("), following the devil (D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDYMUS")]), _vm._v(") and their own natural instincts (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("). The end result is a lasting persistence in evil (B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL")]), _vm._v("), complicity with worldly powers (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(") and the persistent contagion of worldly business (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The one who is blessed delights in the law, expressing wholehearted obedience (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("), motivated not by fear but arising out of the will (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("). By continued meditation on the Word of God, the will is grafted onto God (S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHDONA")]), _vm._v("), and in this way, a person is "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("formed by the Word (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v("). As meditation leads to action (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(", H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("), what was destroyed by Adam is rebuilt (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RNOBIUS THE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNGER")]), _vm._v("). The believer is blessed in knowledge (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(") illumined by the radiance of God (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THANASIUS")]), _vm._v("). Consequently, meditation on the Word should be preferred over other pursuits (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS")]), _vm._v("). On a practical note, a quiet time, such as evening affords, is most advantageous for meditation on the Word (N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICETAS")]), _vm._v("), and meditation is often assisted by conversation and writing (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(").")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The one who is blessed is like a tree of life and wisdom (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("), which is to say, he or she is like Christ (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("), stable in a flood of temporality (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("), bearing fruit by divine enablement (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET")]), _vm._v("). The leaves and fruit are the words and the meaning of Scripture (D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDYMUS")]), _vm._v(", J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). The fruit can also be interpreted as faith and works (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMASCUS")]), _vm._v("), or wisdom (M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETHODIUS OF")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LYMPUS")]), _vm._v(") in the life of a Christian or as the churches that Christ has caused to spring up in the world (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). It can also be understood as immortality (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("), the glorious resurrection (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS")]), _vm._v(") of the believer.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The wicked, however, will be like dust (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v("), insubstantial (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("), driven by every temptation (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). At the resurrection, they have no standing among the righteous (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("); rather, they rise to punishment (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM")]), _vm._v("), being turned back to Sheol (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHRAHAT")]), _vm._v("). Wickedness, consequently, will vanish (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(") as the wicked pass from God’s favorable knowledge (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("1:1a"), _c('i', [_vm._v(" Blessed Is the Man")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDATIONAL FOR THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(".")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v(": Like the foundation in a house, the keel in a ship and the heart in a body, so is [Psalm 1 as a] brief introduction to the whole structure of the Psalms. For when David intended to propose in the course of his speech to the combatants of true religion many painful tasks involving unmeasured sweats and toils, he showed first the happy end, that in the hope of the blessings reserved for us we might endure without grief the sufferings of this life. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 10.3 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 1).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROWN TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFERRED")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(": What a delightfully apt beginning! Those who wish for a grand display and a great celebration to add glory to the games generally promise a prize. They make much of the honor of the crown to be conferred. All this is to make the contestants more eager to take part and to strain every nerve in order to win. This is what our Lord Jesus does. He promises us the glory of a heavenly kingdom, the sweetness of everlasting rest, the happiness of eternal life. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WELVE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.13."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTICIPATION IN")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EING")]), _vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSSA")]), _vm._v(": The goal of the virtuous life is blessedness. . . . This is the summation and object of everything conceived in relation to the good. What is truly and properly contemplated and apprehended in this sublime concept, then, would reasonably be called the divine nature. For so the great Paul designated God when he put “blessed” before all the other words about God in one of his letters. He wrote in the following words, “The blessed and only ruler, the King of kings and Lord of lords, who alone has immortality and who dwells in unapproachable light, whom no human being has seen or can see. To him be honor and rule forever.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" All these sublime concepts about the divine would, then, in my opinion, constitute a definition of blessedness. For if someone were asked what beatitude is, he would give a properly pious answer if he followed Paul’s statement and said that the nature that transcends everything is first and properly called blessed. Among humans, however, that beatitude, which is the nature of the one participated "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("in, occurs to a certain extent and is specified by participation in true being. Likeness to God, therefore, is a definition of human blessedness. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSCRIPTIONS OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.1.5-6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OODNESS")]), _vm._v(".")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v(": What is truly good is principally and primarily the most blessed. And that is God. . . . For truly blessed is Goodness itself toward which all things look, which all things desire, an unchangeable nature, lordly dignity, calm existence; a happy way of life, in which there is no alteration, which no change touches; a flowing fount, abundant grace, inexhaustible treasure. But stupid and worldly people, ignorant of the nature of good itself, frequently bless things worth nothing, riches, health, renown; not one of which is in its nature good, not only because they easily change to the opposite but also because they are unable to make their possessors good. What person is just because of his possessions? What person is self-controlled because of his health? On the contrary, in fact, each of these possessions frequently becomes the servant of sin for those who use them badly. Blessed is the one, then, who possesses that which is esteemed of the greatest value, who shares in the goods that cannot be taken away. How shall we recognize that person? “He who has not walked in the council of the ungodly.” H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 10.3 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 1)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:1b"), _c('i', [_vm._v(" Is the Man Who Does Not Walk, Stand or Sit")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSED")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": This statement should be understood as referring to our Lord Jesus Christ, that is, the Lord-man . . . “who has not gone astray” . . . as did the earthly man who conspired with his wife, already beguiled by the serpent, to disregard God’s commandments. . . . Christ most certainly came in the way of sinners by being born as sinners are, but he did not stand in it, for worldly allurement did not hold him. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITIONS OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSEDNESS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMES FROM")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(".")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USEBIUS OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESAREA")]), _vm._v(": Our Savior, who made many blessed, offers happiness in abundance. He is the first of them who rightly are called blessed. The first psalm, therefore, must refer to him inasmuch as he is the husband of his bride the church. Which, it seems, the Hebrew word for “man” indicates when it is written with the article added. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVED BY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")])]), _vm._v(". J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": We understand this person as one who is claimed and saved by our Savior . . . one and the same the Son of God and the Son of man, who before the ages always was the Word. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIEF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFORMITY TO THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCARNATE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")])]), _vm._v(". H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": The one who is here extolled as happy by the prophet is the person who strives to conform himself to that body that the Lord assumed and in which he was born as human, by zeal for justice and perfect fulfillment of all righteousness. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.4."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMEN")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCLUDED")])]), _vm._v(". B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v(": Why, you say, does the prophet single out only man and proclaim him happy? Does he not exclude women from happiness? By no means. For the virtue of man and woman is the same, since creation is equally honored in both; therefore, there is the same reward for both. Listen to Genesis: “God created humankind,” it says, “In the image of God he created him. Male and female he created them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN46",
      "id": "ap_NFIN46-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" They whose nature is alike have the same reward. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 10.3 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 1)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN47",
      "id": "ap_NFIN47-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVEMENT OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUL")]), _vm._v(".")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v(": He put before us three acts that must be guarded against. . . . In accordance with the nature of things, he set up this order by his words. First, we take counsel with ourselves; "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("next, we strengthen our resolution; then, we continue unchanged in what has been determined. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 10.4 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 1).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN48",
      "id": "ap_NFIN48-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYS OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMITTING")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")])]), _vm._v(". J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": Scripture describes the three usual ways of committing sin: we entertain sinful thoughts; we commit sin in act; or we teach what is sinful. First, we entertain a sinful thought; then, after we have reflected on it, we convert that thought into action. When we commit sin, moreover, we multiply sin by teaching others to do what we have done. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN49",
      "id": "ap_NFIN49-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPENING")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORRUPTION")])]), _vm._v(". E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USEBIUS OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESAREA")]), _vm._v(": The first are the people who are saturated with well-known false reasoning, wicked people who grasp nothing firmly and with stability; they are swayed through their own will with no testing of their oppressive thought. The second are people who time after time fall into sin after the understanding of truth. The third group includes morally corrupt people who labor in no measure of grief, but they will thoroughly fill others with corrupt doctrine, either by their thinking, or by their behavior or by both. These are people who are grounded in evil, while the second group continues in sin and the first walks the way of error. The one who is called blessed is freed and delivered from all of these. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN50",
      "id": "ap_NFIN50-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTERNED")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDEMNATION")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIDORUS")]), _vm._v(": It is important to pay close attention to the order of the text, especially how all of it is directed against Adam. He departed when he abandoned the Lord’s commandment; he stood when he delighted in sin, that is, when he erroneously estimated that he would acquire the knowledge of good and evil. But he sat on the chair of pestilence when he left to his descendants the precedents of a dangerous teaching. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLANATION OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN51",
      "id": "ap_NFIN51-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIN AND")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSUBSTANTIATED")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USINGS")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": Generally there are three types: the first type is the one who does not acknowledge the truth at all, but, as chance has it, when he hands himself over to the vain and unsubstantiated musings of his own heart, he becomes like a wild beast, neither standing nor supported by anything, and accordingly, not sitting. This one, indeed, is said to walk in the counsel of the wicked. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELECTIONS FROM THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN52",
      "id": "ap_NFIN52-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EJECTION OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")])]), _vm._v(". H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": The ungodly are those who despise searching for the knowledge of God, who in their irreverent mind take for granted that there is no Creator of the world, who assert that it arrived at the order and beauty that we see by chance, who in order to deprive their Creator of all power to pass judgment on a life lived rightly or in sin will have it that a person comes into being and passes out of it again by the simple operation of a law of nature. Thus all the counsel of these people is wavering, unsteady and vague and wanders about in the same familiar paths and over the same familiar ground, never finding a resting place, for it fails to reach any definite decision. They have never in their system risen to the doctrine of a Creator of the world, whether the world is for humanity or humanity for the world; the reason for death, its extent and nature. They press in ceaseless motion round the circle of this godless argument and find no rest in these imaginings. There are, besides, other counsels of the ungodly, that is, of those who have fallen into heresy. . . . Their reasoning ever takes the course of a vicious circle; without grasp or foothold to stay them, they tread their interminable round of endless indecision. Their ungodliness consists in measuring God not by his own revelation but by a standard of their choosing; they forget that it is as godless to make a god as to deny him; if you ask them what effect these opinions have on their faith and hope, they are perplexed and confused, they wander from the point and will"), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("fully avoid the real issue of the debate. Happy is the one, then, who has not walked in this kind of counsel of the ungodly, who has not even entertained the wish to walk in it, for it is a sin even to think for a moment of things that are ungodly. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.7-8.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN53",
      "id": "ap_NFIN53-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIL")])]), _vm._v(". D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDYMUS THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIND")]), _vm._v(": The devil himself may be called the way of sinners. Let the one who stands in this way be warned lest he tarry there. Recall what the Scripture says: “Resist the devil, and he will flee from you.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN54",
      "id": "ap_NFIN54-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" For the one who will not stand in the devil’s way will come to the Lord, who says, “I am the way.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN55",
      "id": "ap_NFIN55-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Truly the one who follows this way, traveling the way to the end, will receive a reward. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAGMENTS ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN56",
      "id": "ap_NFIN56-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATH OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURAL")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISPOSITION")])]), _vm._v(". H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": [The psalm here speaks of] those who abide in the church but do not obey its laws; such are the greedy, the drunken, the brawlers, the wanton, the proud, the hypocrites, liars, plunderers. No doubt we are urged toward these sins by the promptings of our natural instincts, but it is good for us to withdraw from the path into which we are being hurried and not to stand in it, seeing that we are offered so easy a way of escape. It is for this reason that the one who has not stood in the way of sinners is happy, for while nature carries him into that way, religious belief draws him back. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.9."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN57",
      "id": "ap_NFIN57-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSISTENCE IN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VIL")])]), _vm._v(". B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIL THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v(": The “chair” here refers to steady and lasting persistence in the choice of evil. This we must guard against because the practice of assiduously occupying ourselves with sins engenders in our soul a certain condition that can scarcely be removed. An inveterate condition of the soul and the exercise of evil strengthened by time are hard to heal or even entirely incurable, since, for the most part, custom is changed into nature. Indeed, not to attach ourselves to evil is a request worth praying for. But there remains a second way: immediately after the temptation to flee it as if it were a venomous sting, according to words of Solomon concerning the wicked woman: “Do not set your eye on her, but leap back; do not delay.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN58",
      "id": "ap_NFIN58-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Now, I know that some in their youth have sunk down into the passions of the flesh and have remained in their sins until their old age because of the habit of evil. As the swine rolling about in the mire always smear more muck on themselves, so these bring on themselves more and more each day the shame of pleasure. Blessed is it, therefore, not to have had evil in your mind; but, if through the deceit of the enemy, you have received in your soul the counsels of impiety, do not stay in your sin. And, if you have experienced this, do not become established in evil. So then, “do not sit in the chair of pestilence.” H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 10.6 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 1)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN59",
      "id": "ap_NFIN59-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPLICITY WITH THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLDLY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWERS")])]), _vm._v(". C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": And “the chair of pestilences” will be the theaters and tribunals, or rather the compliance with wicked and deadly powers and complicity with their deeds. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TROMATEIS")]), _vm._v(" 2.15."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN60",
      "id": "ap_NFIN60-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTAGION OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLDLY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USINESS")])]), _vm._v(". H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": Many, even God-fearing people, are led astray by the canvassing for worldly honors and desire to administer the law of the courts, though they are bound by those of the church. But although they bring to the discharge of their duties a religious intention, as is shown by their merciful and upright demeanor, still they cannot escape a certain contagious infection arising from the business in which their life is spent. For the conduct of civil cases does not suffer them to be true to the holy principles of the church’s law, even though they wish it. And without abandoning their pious purpose they are compelled, against their will, by the "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("necessary conditions of the seat they are prone to use, at one time invective, at another, insult, at another, punishment; and their very position makes them authors as well as victims of the necessity that constrains them, their system being as it were impregnated with the infection. Hence, this title, “the seat of pestilence,” by which the prophet describes their seat, because by its infection it poisons the very will of the religiously minded. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.10.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN61",
      "id": "ap_NFIN61-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:2"), _c('i', [_vm._v(" Delight in the Law")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOLEHEARTED")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BEDIENCE")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": “Delight” refers to the fact that one wholeheartedly obeys the Lord’s command. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN62",
      "id": "ap_NFIN62-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTIVATION")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": The majority of people are kept within the bounds of law by fear; the few are brought under the law by will. For it is the mark of fear not to dare to omit what it is afraid of, but of perfect piety to be ready to obey commands. This is why that one is happy whose will, not whose fear, is in the law of God. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.11."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN63",
      "id": "ap_NFIN63-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAFTING")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLS ONTO")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(".")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHDONA")]), _vm._v(": Let us too do this, meditating continuously on the things of God, and by means of the Lord’s law, let our wills be grafted on to him. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERFECTION")]), _vm._v(" 61."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN64",
      "id": "ap_NFIN64-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMED BY THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v(": One learns to be bound by the law through continuous meditation so that one shapes himself by it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN65",
      "id": "ap_NFIN65-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDITATION")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADS TO")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTION")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": [The blessed person] meditates on the law of the Lord day and night, not as one who entrusts the words of the law to his memory without works, but as one who by meditating performs works consistent with it, until through the disciplined meditation of the works that the law instructs, he is prepared for excelling in all the things that apply for living perfectly according to the law. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELECTIONS FROM THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN66",
      "id": "ap_NFIN66-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDITATION")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERFORMING THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW")]), _vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": Meditation in the law does not lie in reading its words but in pious performance of its injunctions; not in a mere perusal of the books and writings but in a practical meditation and exercise in their respective contents, and in a fulfillment of the law by the works we do by night and day, as the apostle says: “Whether you eat or drink, or whatsoever you do, do all to the glory of God.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN67",
      "id": "ap_NFIN67-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.12."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN68",
      "id": "ap_NFIN68-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBUILDING")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAM")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTROYED")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RNOBIUS THE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNGER")]), _vm._v(": The memory of the law of God overtakes [the blessed person’s] own will. And day and night he models his behavior through meditation on divine law so that the life that Adam destroyed by his contempt, he himself may find by guarding it, remaining deep in the flowing water of the law, taking hold of the everlasting tree of life; so, finally, whatever he does will prosper. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN69",
      "id": "ap_NFIN69-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTINUAL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDITATION")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADS TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSING")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": Certainly, even if I shall not have been able to understand everything, if I am, nevertheless, busily engaged in the divine Scriptures and “I meditate on the law of God day and night” and at no time at all do I desist inquiring, discussing, investigating, and certainly, what is greatest, praying God and asking for understanding from him who “teaches humankind knowledge,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN70",
      "id": "ap_NFIN70-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" I shall appear to dwell “at the well of vision.” . . . You too, therefore, if you shall always search the prophetic visions, if you always "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("inquire, always desire to learn, if you meditate on these things, if you remain in them, you too will receive a blessing from the Lord and dwell “at the well of vision.” For the Lord Jesus will appear to you also, “in the way,” and will open the Scriptures to you so that you may say, “Was not our heart burning within us when he opened to us the Scriptures?”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN71",
      "id": "ap_NFIN71-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" But he appears to those who think about him and meditate on him and live “in his law day and night.” H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENESIS")]), _vm._v(" 11.3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN72",
      "id": "ap_NFIN72-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLUMINED BY THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADIANCE OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THANASIUS")]), _vm._v(": The splendid brilliance of God’s grace never suffers an eclipse. No, it is always at hand to enlighten the inner thoughts of those who really want it. Great good comes to people who, enlightened by the grace of God, make it their habit to apply the truths of holy Scripture to their lives. They receive just such a blessing as the psalmist describes. . . . Those blessings come because the person who accepts God’s grace is not illumined by mere physical light from the sun, the moon or even the whole host of stars. Rather, he glows all over with the radiant brilliance of God. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTERS")]), _vm._v(" 5.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN73",
      "id": "ap_NFIN73-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDITATION")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFERRED TO")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URSUITS")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v(": When we sing, “Blessed is the one who shall meditate on the law of the Lord day and night,” let us reject useless occupations, stinging jests, idle and wicked conversations, as the poison of the devil. Let us frequently read over and over again the divine lessons, or, if we cannot read them ourselves, let us often and eagerly listen to others read them. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON")]), _vm._v(" 75.3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN74",
      "id": "ap_NFIN74-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVANTAGE OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTLY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDITATION")]), _vm._v(".")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICETAS OF")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMESIANA")]), _vm._v(": Meditation during the day is, of course, good, but that at night is better. During the day, there is the clamor of our many cares, the mental distraction of our occupations. A double preoccupation divides our attention. The quiet and solitude of the night make it a favorable time for prayer and most suitable for those who watch. With worldly occupations put aside and the attention undivided, the whole person, at night, stands in the divine presence. V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGILS OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINTS")]), _vm._v(" 8."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN75",
      "id": "ap_NFIN75-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDITATION")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSISTED BY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONVERSATION AND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITING")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": As for myself, I meditate on the law of God, if not day and night, at least during the few moments of time that I can, and lest my meditations escape from me through forgetfulness, I hold on to them by my pen. I am confident that God in his mercy will make me remain steadfast in all the truths that I regard as certain, but if I am minded otherwise in any point, he will make it known to me, either by his own secret inspirations, or through his own lucid words or through discussions with my brethren. For this do I pray, and I place this trust and my own desires in his hands, who is wholly capable of guarding what he has given and of fulfilling what he has promised. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY")]), _vm._v(" 1.3.5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN76",
      "id": "ap_NFIN76-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:3"), _c('i', [_vm._v(" Like a Tree by Streams of Water")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REE OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISDOM")]), _vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": In the book of Genesis, it is stated that there stands in the midst of the garden a tree of life and a tree of the knowledge of good and evil; next, that the garden is watered by a stream that afterwards divides into four heads. The prophet Solomon teaches us what this tree of life is in his exhortation concerning Wisdom: “She is a tree of life to all those that lay hold on her and lean on her.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN77",
      "id": "ap_NFIN77-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" This tree, then, is living; and not only living, but, furthermore, guided by reason; guided by reason, that is, insofar as to yield fruit in its own season. And this tree is planted beside the rills of water in the domain of the kingdom of God, that is, of course, in paradise, and in the place where the stream as it "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("issues forth is divided into four heads. . . . This tree is planted in that place wither the Lord, who is Wisdom, leads the thief who confessed him to the Lord, saying, “Truly I say to you, today you will be with me in paradise.” . . . The blessed person, then, will become like this tree when he or she shall be transplanted as the thief was, into the garden and set to grow beside the rills of water; and this planting will be that happy new planting that cannot be uprooted, to which the Lord refers in the Gospels when he curses the other kind of planting and says, “Every planting that my Father has not planted shall be rooted up.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN78",
      "id": "ap_NFIN78-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" This tree, therefore, will yield its fruits. Homily on Psalm 1.14-15."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN79",
      "id": "ap_NFIN79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": When Solomon says, “She is a tree of life to those who grasp her,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN80",
      "id": "ap_NFIN80-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" he is speaking of Wisdom. Now, if wisdom is the tree of life, Wisdom itself, indeed, is Christ. You understand now that the one who is blessed and holy is compared with this tree, that is, with Wisdom. . . . He is, in other words, like Christ. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN81",
      "id": "ap_NFIN81-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TABLE IN A")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOOD OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMPORALITY")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": What do you want? To have temporal things and to pass away together with time or not to love the world and to live forever with God? The river of temporal things carries [us] along, but like a tree growing near a river is our Lord Jesus Christ. He assumed flesh, died, rose again, ascended into heaven. He wanted, so to speak, to plant himself near the river of temporal things. Are you being swept headlong? Take hold of the wood. Does love of the world whirl you about? Take hold of Christ. For your sake was the temporal made that you may become eternal. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" 1 J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 2.10.2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN82",
      "id": "ap_NFIN82-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TREAMS OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v(": The streams from the divine Spirit resemble watering by rivers: just as they cause trees planted near them to flourish, so the spiritual streams are the cause of bearing divine fruit. For this very reason Christ the Lord called his own teaching water. . . . Appropriately, then, blessed David compared the person devoted to the divine sayings with trees growing on riverbanks, ever green, bearing fruit in season. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.7-8."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN83",
      "id": "ap_NFIN83-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDS AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENSE OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])]), _vm._v(". D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDYMUS THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIND")]), _vm._v(": The tree is the wisdom of God; its fruit the mystical and spiritual sense of the Scriptures; the leaves covering its fruits are external words, which besides protecting the fruits display appropriate behavior, and they become the nourishment of good people, who are called beasts of burden on account of their own simplicity. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAGMENTS ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN84",
      "id": "ap_NFIN84-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUIT AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLIAGE")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": This tree bears twofold: it produces fruit, and it produces foliage. The fruit that it bears contains the meaning of Scripture; the leaves, only the words. The fruit is in the meaning; the leaves are in the words. . . . Whoever reads sacred Scripture . . . with true spiritual insight gathers the fruit. . . . The leaves of this tree are by no means useless [“and whose leaves never fade”]. Even if one understands holy Writ only as history, he has something useful for his soul. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN85",
      "id": "ap_NFIN85-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH AND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMASCUS")]), _vm._v(": The soul watered by sacred Scripture grows fat and bears fruit in due season, which is the orthodox faith, and so is it adorned with its evergreen leaves, with actions pleasing to God, I mean. And thus we are disposed to virtuous action and untroubled contemplation by the sacred Scriptures. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHODOX")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(" 4.17."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN86",
      "id": "ap_NFIN86-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUIT OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISDOM")]), _vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETHODIUS")]), _vm._v(": “A tree planted by the waterside, that will bring forth "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("his fruit in due season”; that is, learning and charity and discretion are imparted in due time to those who come to the waters of redemption. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANQUET OF THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRGINS")]), _vm._v(" 9.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN87",
      "id": "ap_NFIN87-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCHES")]), _vm._v(","), _c('span', {
    staticClass: "small"
  }, [_vm._v(" THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUIT OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": That tree, therefore, is our Lord, who draws those who are in the way from the running waters, that is, from the peoples who sin. By drawing them into the roots of his disci-pline, he will bring forth fruit; that is, he will establish churches, but in due time, that is, after he has been glorified by his resurrection and ascension into heaven. Once the Holy Spirit had been sent to the apostles, and once they had been established in their faith in him and sent out to the peoples, he bore the churches as his fruit. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITIONS OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN88",
      "id": "ap_NFIN88-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUIT OF")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MMORTALITY")]), _vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": Now what, you ask, is this fruit that is to be dispensed? That assuredly of which this same apostle is speaking when he says, “And he will change our vile body, that it may be fashioned like his glorious body.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN89",
      "id": "ap_NFIN89-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Thus he will give us those fruits of his that he has already brought to perfection in that one whom he has chosen to himself, who is portrayed under the image of a tree, whose mortality he has utterly done away and has raised him to share in his own immortality. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.15."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN90",
      "id": "ap_NFIN90-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORIOUS")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v(": O blessed cross, which makes people blessed! O cross, from which such great and wonderful fruits are gathered! The fruit of the cross is a glorious resurrection. This fruit of the wood is truly planted “near running water,” for baptism is always joined to the cross. However, this wood produced “its fruit in due season,” at the Lord’s resurrection. It will do so again when he appears from heaven, “is seen on earth,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN91",
      "id": "ap_NFIN91-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" and with dazzling sign of the cross preceding him, comes from above. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON")]), _vm._v(" 112.4."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN92",
      "id": "ap_NFIN92-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:4"), _c('i', [_vm._v(" Like Dust Blown by the Wind")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST")]), _vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS")]), _vm._v(": The ungodly have no possible hope of having the image of the happy tree applied to them. The only lot that awaits them is one of wandering and winnowing, crushing, dispersion and unrest; shaken out of the solid framework of their bodily condition, they must be swept away to punishment in dust, a plaything of the wind. They shall not be dissolved into nothing, for punishment must find in them some stuff to work on, but ground into particles imponderable, unsubstantial, dry, they shall be tossed to and fro and make sport for the punishment that gives them no rest. Their punishment is recorded by the same prophet in another place where he says, “I will beat them small as the dust before the wind; like the mire of the streets I will destroy them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN93",
      "id": "ap_NFIN93-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1.19."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN94",
      "id": "ap_NFIN94-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSUBSTANTIAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XISTENCE")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": Dust does not seem to have any substance, but it does, of course, have a kind of existence of its own. There is no body to it, yet what substance it does have is really by way of punishment. It is scattered here and there and is never in any one place; wherever the wind sweeps it, there its whole force is spent. The same is true of the wicked person. Once he has denied God, he is led by delusion wherever the breath of the devil sends him. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN95",
      "id": "ap_NFIN95-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIVEN BY")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMPTATION")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v(": Even as chaff lies exposed to the gusts of wind and is easily caught up and swept along, so is also the sinner driven about by every temptation; for while a sinner is at war with himself and bears the warfare about with him, what hope of safety does he possess; betrayed as he is "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("at home, carrying with him that conscience that is a constant enemy? H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCERNING THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATUES")]), _vm._v(" 8.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN96",
      "id": "ap_NFIN96-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:5"), _c('i', [_vm._v(" The Wicked and the Judgment")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TANDING")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": Let us at this point consider the meaning of the words “therefore in judgment the wicked shall not stand.” They shall not rise to be judged because they have already been judged, for “he who does not believe in me is already judged,” “nor shall sinners in the assembly of the just.” It does not say that sinners shall not rise again but that they shall not stand in the assembly of the just; they do not deserve to stand with those who are not to be judged. If they believed in me, says the Lord, they would rise up with those who do not have to be judged. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN97",
      "id": "ap_NFIN97-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION TO")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNISHMENT")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM")]), _vm._v(": They shall rise, though not to be judged, but to be sentenced. For God needs no lengthy scrutiny, but as soon as the wicked rise again, their punishment forthwith follows. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATECHETICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTURES")]), _vm._v(" 18.14."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN98",
      "id": "ap_NFIN98-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URNED")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACK TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOL")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHRAHAT")]), _vm._v(": And even as the righteous who are perfected in good works shall not come into the judgment to be judged, so of the wicked also whose sins are many, and the measure of whose offenses is overflowing, it shall not be required that they should draw near to the judgment, but when they have risen again they shall turn back to Sheol. . . . All the nations that know not God their Maker are esteemed by God as nothingness and shall not come near to judgment, but as soon as they have risen shall turn back to Sheol. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMONSTRATIONS")]), _vm._v(" 22.17."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN99",
      "id": "ap_NFIN99-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:6"), _c('i', [_vm._v(" The Two Ways")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANISHING")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICKEDNESS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": If the wicked perish, there is no chance for their repentance. It does not say that the wicked shall perish but that the way of the wicked vanishes, that is, wickedness shall perish. Not the wicked but wickedness itself; not the one who was wicked will perish, but while he is repenting, wickedness vanishes. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN100",
      "id": "ap_NFIN100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWLEDGE AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GNORANCE OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": God is ignorant of evil deeds, not because he is unable to understand everything or to grasp it with his own intelligence (for it is wrong to think this way about God) but because those deeds are unworthy of his contemplation. . . . God is ignorant of the way of the wicked, and he knows the way of the righteous. Further, who is the way of the righteous except the one who said, “I am the way” whom the Father knows? “No one has known the Son except the Father.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN101",
      "id": "ap_NFIN101-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" The distinction between the knowledge and ignorance of God is referred to in the prophets as “the memory and forgetfulness” of God. Often it is said in prayer: “Be mindful of me” and “Why have you forgotten our poverty?” Just as God removes sinners from his own memory, so does he again receive the repentant and become mindful of them. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELECTIONS FROM THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.6."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN102",
      "id": "ap_NFIN102-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWLEDGE AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XISTENCE")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": The Lord knows the way of the just but does not know the way of the ungodly. This does not mean that there is anything the Lord does not know, but he did say to sinners, “I never knew you.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN103",
      "id": "ap_NFIN103-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" However, to say “the way of the ungodly will perish” is substantially the same as saying, “The Lord does not know the way of the ungodly”; but it makes the point clearer that to be unknown to the Lord is to perish, and to be known by him is to remain. Thus being corresponds to God’s knowledge and nonexistence to not being known. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITIONS OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1.6."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN104",
      "id": "ap_NFIN104-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 81
// module chunks = 0